const doc = [({"ja":({"adminConstantGenderType":({"man":"男性", "woman":"女性"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;